import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import DigitalCard from "./components/DigitalCard";
import { hasLogged, markLogged } from "./utils/analyticsGuard";

function GuardedCard() {
  const { token } = useParams();
  const normalized = token?.toLowerCase().trim();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/users.json")
      .then((res) => res.json())
      .then((users) => {
        setUser(users[normalized] || null);
        setLoading(false);
      })
      .catch(() => {
        setUser(null);
        setLoading(false);
      });
  }, [normalized]);

  useEffect(() => {
    if (!user) return;

    const key = `qr_scan_${normalized}`;
    if (hasLogged(key)) return;

    fetch("https://bcard-api.visionwaretechnologies.com/api/qr/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userGuid: normalized,
        eventType: "QR_SCAN"
      })
    })
      .then(() => markLogged(key))
      .catch(() => {
        // silently ignore analytics errors
      });
  }, [normalized, user]);

  if (loading) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <h2>Link Invalid or Expired</h2>
        <p>Please contact us for an updated business card.</p>
        <h3><a href="https://visionwaretechnologies.com/contact">Visionware Technologies</a></h3>
      </div>
    );
  }

  return <DigitalCard user={user} token={normalized} />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:token" element={<GuardedCard />} />
        <Route path="/ping" element={<pre>ok</pre>} />
        <Route path="*" element={<Navigate to="https://visionwaretechnologies.com" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
